import { EmployeeHiresService } from "./../../../services/documents/EmployeeHiresService";
import React from "react";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { CreateEmployeeHiresDto } from "../../../dtos/documents/EmployeeHires/CreateEmployeeHiresDto";
import { EmployeeHiresDetail } from "../../../components/Pages/Documents/EmployeeHires/EmployeeHiresDetail";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupEmployeeHires } from "../../../components/Shared/NewForms/NFLookupEmployeeHires";
import EmployeeHiresList from "../../../components/Pages/Documents/EmployeeHires/EmployeeHiresList";

export const EmployeeHires: IAppEntity = {
  entityType: "document",
  title: "Employee Hires",
  pluralTitle: "Employee Hires",
  apiUrl: "EmployeeHires",
  apiEnum: ReferenceTypes.DocumentEmployeeHire,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(EmployeeHiresDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(EmployeeHiresList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupEmployeeHires, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new EmployeeHiresService("EmployeeHires"),
  getEmptyModel: () => {
    const model: CreateEmployeeHiresDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
      documentNumber: "",
      hireDate: new Date(),
    };
    return model;
  },
};
